/**
 * Puts the applied values at the top of a filter's options, so a long list
 * needs no scrolling to find them. Pass the applied values, not the pending
 * picks: the rows must not move under the cursor while the user clicks.
 */
export const pinSelectedFirst = <T extends { value: string }>(
  items: T[],
  selectedValues: string[]
): T[] => [
  ...items.filter((item) => selectedValues.includes(item.value)),
  ...items.filter((item) => !selectedValues.includes(item.value))
];
